import { makeRetriableGetRequest } from '../api/apiActions';

class SpellingServiceClient {
    static NAME = 'spelling';

    static URL = '/lanternspelling/v01';

    static RESULT_OPERATION = {
        ADD_RESPONSE: 'add_response',
        ADD_RESPONSE_WITH_COMPLETE: 'add_response_with_complete',
    };

    static MEASURES = {
        SPELLING: 'SPELLING',
    };

    /**
     * Constructs request url to Lantern Spelling service based on the passed config object.
     * config may include:
     - grade
     - period
     */
    static constructFormEndpoint({ grade, period, language } = {}) {
        let endpoint = `${SpellingServiceClient.URL}/forms`;
        const params = [];

        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (language) {
            params.push(`language=${language}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Sends GET request to results endpoint with provided parameters
     * @param {str} measure - (optional) specified measure of Vocabulary asessment
     * @param {str} grade - (optional) student's grade
     * @param {str} period - (optional) BOY | MOY | EOY
     * @param {str} language - (optional) current language
     * @returns {JSON} server response
     */
    static getForm = (grade, period, language, retryActionName) => (dispatch) => {
        const config = {
            grade,
            period,
            language,
        };

        const endpoint = SpellingServiceClient.constructFormEndpoint(config);
        return dispatch(makeRetriableGetRequest(endpoint, retryActionName));
    };

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({
        studentId, grade, period, schoolYear, language,
    } = {}) {
        let endpoint = `${SpellingServiceClient.URL}/results`;
        const params = [];

        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (language) {
            params.push(`language=${language}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for creating result
     */
    static constructCreateResultEndpoint() {
        return `${SpellingServiceClient.URL}/results`;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructSaveResultEndpoint(resultId) {
        return `${SpellingServiceClient.URL}/results/${resultId}`;
    }
}

export default SpellingServiceClient;
